import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { AuthService, UserDataModel } from '../../../modules/auth';
import { ResponseModel } from '../../../modules/auth/_models/response.model';
import { DashboardService } from '@services/DashboardService/dashboard.service';
import { Reply } from '../../../modules/post/_models/post-reply-view.model';
import { isUserNotBasic } from '@models/utils';
import { LikesService } from '@services/LikesService/likes.service';

@Component({
  selector: 'app-view-post-reply',
  templateUrl: './view-post-reply.component.html',
  styleUrls: ['./view-post-reply.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewPostReplyComponent implements OnInit {
  @Input() reply: Reply;
  isDeleted = false;
  currentUser: UserDataModel;
  isAdmin = false;

  constructor(
    private dashboardService: DashboardService,
    private changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService,
    private likesService: LikesService,
  ) {
  }

  ngOnInit(): void {
    this.authService.currentUser$.pipe(first()).subscribe(user => {
      this.currentUser = user;
      this.isAdmin = isUserNotBasic(this.currentUser);
      this.changeDetectorRef.detectChanges();
    });
  }

  deleteReply(e: Event, id: number) {
    this.dashboardService.deleteReply(id)
      .pipe(first())
      .subscribe((response: ResponseModel<boolean>) => {
        if (response) {
          this.isDeleted = true;
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  public toggleLikeReply() {
    (
      this.reply.isLiked ? 
      this.likesService.unlikeReply(this.reply.id) : 
      this.likesService.likeReply(this.reply.id)
    )
      .pipe(first())
      .subscribe((response: ResponseModel<Reply>) => {
        if (response.data) {
          this.reply.lastLikeUserProfile = response.data.lastLikeUserProfile;
          this.reply.likesCount = response.data.likesCount;
          this.reply.isLiked = !this.reply.isLiked;
          this.changeDetectorRef.markForCheck();
        }
      });
  }
}
